export default "//0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/209a35538f509f57be146cd97fdd4df4.svg";